import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=e0ce5488&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=e0ce5488&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ce5488",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0ce5488')) {
      api.createRecord('e0ce5488', component.options)
    } else {
      api.reload('e0ce5488', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=e0ce5488&scoped=true", function () {
      api.rerender('e0ce5488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/documents/preview.vue"
export default component.exports